'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './payments-overview.routes';

export class PaymentsOverviewComponent {
  constructor(StripeService, $stateParams, $window, ContactService, DTOptionsBuilder, $filter,
              $scope, ViewSelection, DTDefaultOptions, DTState, WebAccessService, CommunityService) {
    'ngInject';

    this.$scope = $scope;
    this.ViewSelection = ViewSelection;

    this.WebAccessService = WebAccessService;
    this.CommunityService = CommunityService;

    this.contactId = $stateParams.contactId;
    this.back = _ => $window.history.back();

    this.mapContact = {};

    this.count = {all: 0, paid: 0, failed: 0};

    $scope.ViewSelection = ViewSelection;
    $scope.$watch('ViewSelection.selectedCommunity', (newVal, oldVal, scope) => {
      this.selectedCommunity = newVal.name;
      this.selectedCommunityCode = newVal.value;
      this.filterData(this.selectedCommunityCode, this.cat);
    });

    this.data = [];

    this.WebAccessService.query(data => {
      data.forEach(wa => this.mapContact[wa._id] = wa);

      this.connectedAccountMap = {};
      CommunityService.query(cmtys => {
        cmtys
          .filter(cmty => cmty.stripe && cmty.stripe.enabled && cmty.stripe.connectedAccountIds.length)
          .forEach(cmty => {
            this.connectedAccountMap[cmty.code] = cmty.stripe.connectedAccountIds
          });

        let fnDone = ()=>{
          this.filterData(ViewSelection.selectedCommunityCode);
          this.dataInitComplete = true;

          let asnDistChart = {};

          this.data.forEach(li => {
            let key = li.code;
            if (!asnDistChart[key]) {
              asnDistChart[key] = {
                paid: 0,
                failed: 0
              };
            }

            if (li.paid) {
              asnDistChart[key].paid++;
            } else {
              asnDistChart[key].failed++;
            }
          });

          Object.keys(asnDistChart).forEach(code => {
            this.chartLabels['asn'].push(code);
            this.chartData['asn'][0].push(asnDistChart[code].paid);
            this.chartData['asn'][1].push(asnDistChart[code].failed);
          });

        };

        let codes = Object.keys(this.connectedAccountMap);
        let codesDone=0;
        if (codes.length) {
          codes.forEach(cmtyCode => {

            let idsDone=0;
            let idsLength = this.connectedAccountMap[cmtyCode].length;

            this.connectedAccountMap[cmtyCode].forEach(id => {
              StripeService.getPayments({id: id},data => {
                this.data = this.data.concat(data.map(li => {
                  li.code = cmtyCode;
                  return li;
                }));

                idsDone++;

                if (idsDone == idsLength)
                  codesDone++;

                if (codesDone == codes.length)
                  fnDone();
              }, err => {
                console.log(err);

                idsDone++;

                if (idsDone == idsLength)
                  codesDone++;

                codesDone++;
                if (codesDone == codes.length)
                  fnDone();
              });
            })

          });
        }
      });

    }, err => {
      console.log("Could not retrieve website access.")
    });

    this.chartData = {
      'dist': [],
      'asn': [[],[]]
    };
    this.chartLabels = {
      'dist': ["Paid","Failed"],
      'asn': []
    };
    this.chartColors = {
      'dist': ['#2ECC71', '#C70039'],
      'asn':  ['#2ECC71', '#C70039']
    };

    this.chartSeries = {
      'asn': ["Paid","Failed"]
    };

    this.chartOptions = {
      'dist': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Payment Status'
        },
        animation: false
      },
      'asn': {
        title: {
          display: true,
          text: 'Payment Status per Association'
        },
        animation: false,
        plugins: {
          stacked100: { enable: true }
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    };

    DTDefaultOptions.setLoadingTemplate( "<datatable-loading-placeholder columns='Contact, Account, Community, Import Date, Balance />");

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [[0, 'asc'],[1, 'asc']])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Payments"
      },{
        extend: 'csv',
        title: "Payments"
      },{
        title: "Payments",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Payments"
      }])
      .withOption('fnFooterCallback', function ( row, data, start, end, display ) {
        var api = this.api(), data;

        // Remove the formatting to get integer data for summation
        var intVal = function ( i ) {
          return typeof i === 'string' ?
            i.replace(/[\$,]/g, '')*1 :
            typeof i === 'number' ?
              i : 0;
        };

        var roundCorrectly = function(number){ return Math.round(number * 100)/100 };

        // Total over all pages
        var total = api
          .column( 1 )
          .data()
          .reduce( function (a, b) {
            return intVal(a) + intVal(b);
          }, 0 );

        // Total over this page
        var pageTotal = api
          .column( 1, { page: 'current'} )
          .data()
          .reduce( function (a, b) {
          }, 0 );

        // Total over this page
        var visibleTotal = api
          .column( 1, { search: 'applied'} )
          .data()
          .reduce( function (a, b) {
            return intVal(a) + intVal(b);
          }, 0 );

        // Update footer
        $( api.column( 1 ).footer() ).html(
          '<nobr>$ '+ $filter('number')(roundCorrectly(visibleTotal), 2) + '</nobr>'
        );
      });


  }

  getPrimaryOwner(property) {
    let primary = property.contacts.find(c => c.type == 'primary-owner');
    if (primary)
      return primary.contact;
    else
      return null;
  }

  getPrimaryOwnerId(property) {
    let primary = this.getPrimaryOwner(property);
    if (primary)
      return primary._id;
  }

  roundCorrectly(number) {
    /*
     * var x = 1243.95;
     *     x += -414.65;  --> x = 829.3000000000001 wooot ??
     */
    return Math.round(number * 100)/100;
  }

  filterData(code, cat) {

    if (code) {
      this.filteredData = this.data.filter(li => li.code == code)
    } else {
      this.filteredData = this.data;
    }

    this.count.all = this.getCount('all');
    this.count.paid = this.getCount('paid');
    this.count.failed = this.getCount('failed');

    this.chartData['dist'] = [this.count.paid, this.count.failed];

    if (cat && cat !== 'all') {
      switch (cat) {
        case 'paid':
          this.filteredData = this.filteredData.filter(li => li.paid);
          break;
        case 'failed':
          this.filteredData = this.filteredData.filter(li => !li.paid);
          break;
      }
    }
  }

  getCount(cat) {
    if (!this.filteredData || !this.filteredData.length)
      return 0;

    return this.filteredData.filter(li => {
      switch (cat) {
        case 'paid':
          return li.paid;
        case 'failed':
          return !li.paid;
        default:
          return true;
      }
    }).length;
  }

  setFilter(cat) {
    this.cat = cat;
    this.filterData(this.selectedCommunityCode, this.cat);
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }
}

export default angular.module('conduu.paymentsOverview', [uiRouter])
  .config(routes)
  .component('paymentsOverview', {
    template: require('./payments-overview.html'),
    controller: PaymentsOverviewComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/payments/overview/payments-overview.component.js